import { Flame, Timer } from "lucide-react";
import { GlassCard } from "@/components/GlassCard";
import { useLanguage } from "@/i18n/LanguageContext";

const MiniStat = ({ icon: Icon, iconClass, label, value, unit, testId }) => (
  <GlassCard className="p-4">
    <div className="flex items-center gap-2 text-[hsl(var(--muted-foreground))]">
      <Icon size={14} className={iconClass} />
      <span className="text-xs">{label}</span>
    </div>
    <p
      data-testid={testId}
      className="mt-2 text-2xl font-semibold font-heading [font-variant-numeric:tabular-nums]"
    >
      {value}
      <span className="text-sm text-[hsl(var(--muted-foreground))] font-normal ml-1">
        {unit}
      </span>
    </p>
  </GlassCard>
);

export const MiniStats = ({ stats, loading }) => {
  const { t } = useLanguage();
  return (
    <div className="grid grid-cols-2 gap-3">
      <MiniStat
        icon={Timer}
        label={t("dashboard.activeThisWeek")}
        value={loading ? "\u2014" : stats.weekly_minutes}
        unit={t("common.min")}
        testId="dashboard-minutes-this-week"
      />
      <MiniStat
        icon={Flame}
        iconClass="text-amber-400/80"
        label={t("dashboard.currentStreak")}
        value={loading ? "\u2014" : stats.current_streak}
        unit={
          !loading && stats.current_streak === 1 ? t("common.day") : t("common.days")
        }
        testId="dashboard-current-streak"
      />
    </div>
  );
};
